import { get } from 'lodash';
import { lowesImageUrl, productJsonProps, lowesDomainUrl } from '../Constants/Products';
import { getLocalDateTime } from './GlobalUtils';

export const getProductImgUrl = (product) => {
	let productImageUrl = '';
	const imgUrl = get(product, productJsonProps.image);
	if (imgUrl) {
		productImageUrl = `${lowesImageUrl}${imgUrl[0].value}`;
	}
	return productImageUrl;
};
export const getProductPdpUrl = (product) => {
	let pdpUrl = '';
	if (product?.product?.pdURL) {
		pdpUrl = `${lowesDomainUrl}${product.product.pdURL}`;
	}
	return pdpUrl;
};
export const getProductUpdatedTime = (product) => {
	let lastUpdatedTime = '';
	const metaData = product?.meta;
	if (metaData?.lastUpdated) {
		lastUpdatedTime = getLocalDateTime(metaData.lastUpdated + ' UTC');
	}
	return lastUpdatedTime;
};
export const formatIVM = (product) => {
	if (product.product) {
		const itemNumber = get(product, productJsonProps.itemNumber, '');
		const vendorNumber = get(product, productJsonProps.vendorNumber, '');
		const modelNumber = get(product, productJsonProps.modelId, '');
		return `${itemNumber}-${vendorNumber}-${modelNumber}`;
	}
	return '';
};
